import React from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import { FolderOpen } from 'lucide-react'

interface PortfoliosEmptyStateProps {
	// Optional: when omitted (e.g. a read-only community account), the create
	// CTA is hidden and the copy adjusts.
	onCreatePortfolio?: () => void
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 3rem 1.5rem;
	text-align: center;
	background: #ffffff;
	border: 1px dashed rgba(0, 0, 0, 0.08);
	border-radius: 12px;
	color: #2d3748;
	width: 100%;
`

const IconWrapper = styled.div`
	width: 96px;
	height: 96px;
	border-radius: 9999px;
	background: rgba(0, 128, 254, 0.08);
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 24px;

	svg {
		width: 48px;
		height: 48px;
		color: #0080fe;
	}
`

const Title = styled.h3`
	font-size: 1.375rem;
	font-weight: 700;
	margin-bottom: 0.5rem;
`

const Description = styled.p`
	max-width: 520px;
	margin: 0 auto 2rem;
	line-height: 1.6;
	color: #4a5568;
`

const PortfoliosEmptyState: React.FC<PortfoliosEmptyStateProps> = ({ onCreatePortfolio }) => {
	return (
		<Container>
			<IconWrapper>
				<FolderOpen className="w-4 h-4" />
			</IconWrapper>
			<Title>No Portfolios Yet</Title>
			<Description>
				{onCreatePortfolio
					? 'Organize your locations into portfolios to better manage and track multiple sites. Portfolios help you group related locations and streamline your workflow.'
					: 'No portfolios have been shared with you yet. Portfolios you are invited to as a partner will appear here.'}
			</Description>
			{onCreatePortfolio && (
				<Button variant="primary" isInput onClick={onCreatePortfolio}>
					Create New Portfolio
				</Button>
			)}
		</Container>
	)
}

export default PortfoliosEmptyState
